import {
  BlacklistQuery,
  BlacklistQueryChange,
  SaveBlacklistQueriesRequest,
  SearchBlacklistQueriesRequest,
  SearchBlacklistQueriesResponse,
} from "@radarly/models/blacklist-queries";

export interface Pagination {
  start: number;
  limit: number;
}

export interface BlacklistQueriesRepository {
  searchBlacklistQueries(
    project: number,
    payload: SearchBlacklistQueriesRequest
  ): Promise<SearchBlacklistQueriesResponse>;
  getBlacklistQuery(project: number, qid: number): Promise<BlacklistQuery>;
  createBlacklistQuery(
    project: number,
    payload: SaveBlacklistQueriesRequest
  ): Promise<BlacklistQuery>;
  updateBlacklistQuery(
    project: number,
    qid: number,
    query: BlacklistQuery
  ): Promise<BlacklistQuery>;
  deleteBlacklistQuery(project: number, qid: number): Promise<BlacklistQuery>;
  getBlacklistQueryChangeLog: (
    project: number,
    focus: number,
    pagination: Pagination
  ) => Promise<{
    changelog: BlacklistQueryChange[];
    total: number;
  }>;
}

export const BlacklistQueriesRepositoryUID = Symbol(
  "Radarly/BlacklistQueriesRepository"
);
